/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { url } from 'utils/urls';
import PercentageBar from 'components/shared/percentagebar/percentagebar';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/image1/answer/answer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ IMAGE 1 ANSWER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const Image1Answer = (props) => {
	let inlineStyles = {
		'background-image': `url('${url.image.client}${props.image}')`
	};
    return(
        <span className={`${sheet.classes.uniqueanswer} uniqueanswer`}>
        	<span className={`group`}>
	        	<span className={`${sheet.classes.graphic} graphic`} style={inlineStyles}><span className={`fade`}></span></span>
	            <span className={`${sheet.classes.desc} desc`}><span className={`text`}>{props.text}</span></span>
	        </span>
            { props.isResult ? <PercentageBar type={`vertical1`} barCoefficient={props.barCoefficient} amount={`${props.predictionPercentage}`} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} /> : null }
        </span>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Image1Answer;
